
export default {
  name: "TestView",
  middleware: ["auth"],
}
